// extracted by mini-css-extract-plugin
export var itemInfo = "cart-item-module--itemInfo--TWuqp";
export var itemQuantitySelector = "cart-item-module--itemQuantitySelector--T6mJi";
export var removeItemButton = "cart-item-module--removeItemButton---GUC6";
export var thumbWrap = "cart-item-module--thumbWrap--CnnNk";